import React, { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import Container from "react-bootstrap/Container";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { QueryClientProvider } from "@tanstack/react-query";
import { Provider as JotaiProvider } from "jotai";

import "./App.scss";
import router from "./router";
import { PwaContextProvider } from "./context/pwa-context";
import { queryClient } from "./react-query/query-client";
import LoadingOverlay from "./components/LoadingOverlay/LoadingOverlay";
import { initializePostHog } from "./config/posthog";
import { initializeSingular } from "./config/singular";

initializePostHog();
initializeSingular();

function App() {
  return (
    <HelmetProvider>
      <PwaContextProvider>
        <QueryClientProvider client={queryClient}>
          <JotaiProvider>
            <Container fluid as="main" className="App p-0">
              <Suspense fallback={<LoadingOverlay />}>
                <RouterProvider router={router} />
              </Suspense>
              <Toaster toastOptions={{ duration: 3000 }} />
            </Container>
          </JotaiProvider>
        </QueryClientProvider>
      </PwaContextProvider>
    </HelmetProvider>
  );
}

export default App;
